// extracted by mini-css-extract-plugin
export var background = "TravelHero-module--background--33d71";
export var buttonContainer = "TravelHero-module--button-container--2c270";
export var container = "TravelHero-module--container--c3d85";
export var content = "TravelHero-module--content--546f1";
export var diver = "TravelHero-module--diver--7538d";
export var hideAnimatedContent = "TravelHero-module--hideAnimatedContent--c39e1";
export var intro = "TravelHero-module--intro--205ef";
export var jetty = "TravelHero-module--jetty--d4666";
export var lgBreak = "1200";
export var mdBreak = "992";
export var smBreak = "768";
export var title = "TravelHero-module--title--13779";
export var titleCharacter = "TravelHero-module--title-character--ee8bb";
export var titleLine = "TravelHero-module--title-line--77a9a";
export var travelHero = "TravelHero-module--travel-hero--2bbcb";
export var xsBreak = "480";